//
//
//
//
//
//
//
//
//
//

import { Banner } from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import { trackClick } from '@tracking/events'

export default {
  components: {
    Banner,
  },

  props: {
    page: {
      type: String,
      required: true,
    },
    bannerId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      skinnyBanner: 'countryConfig/skinnyBanner',
      isDisplayed: 'countryConfig/isSkinnyBannerDisplayed',
    }),

    props() {
      const {
        cta_text: cta,
        text,
        name,
        target_blank: blank,
        link,
      } = this.skinnyBanner(this.page, this.bannerId)

      return {
        to: link,
        label: text,
        cta,
        name,
        target: blank ? '_blank' : '_self',
      }
    },
  },

  methods: {
    sendMarketingData() {
      trackClick({
        name: this.props.name,
        zone: 'skinnyBanner',
      })
    },

    closeBanner() {
      this.$store.dispatch('countryConfig/closeSkinnyBanner')
    },
  },
}
